import store from '@/store';
import * as apiUploadDebtors from '../api/uploadDebtors';

export default {
    namespaced: true,
    state: {
    },
    mutations: {},
    getters: {
        orgId(){
            return store.getters['organization/ID_ORG'];
        },
        wsId(){
            return store.getters['workspace/ID_WORK_SPACE'];
        },
    },
    actions: {
        async normalize({getters}, payload){
            return apiUploadDebtors.normalize(getters.wsId, getters.orgId, payload.id);
        },
        async upload({getters}, payload){
            return apiUploadDebtors.upload(getters.wsId, getters.orgId, payload);
        },
        async getTemplate({getters}){
            return apiUploadDebtors.getTemplate(getters.wsId, getters.orgId);
        },
        async getUpload({getters}, payload){
            return apiUploadDebtors.getUpload(getters.wsId, getters.orgId, payload.id);
        },
        async execute({getters}, payload){
            return apiUploadDebtors.execute(getters.wsId, getters.orgId, payload.id, payload.data);
        },
        async identifyHouseAddress({getters}, payload){
            return apiUploadDebtors.identifyHouseAddress(getters.wsId, getters.orgId, payload.id);
        },
    }
}